module.exports = __webpack_public_path__ + "static/media/urban-farming-mobile.7bf0d4d3.jpg";